import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ACHero from './components/ACHero';
import ACIntro from './components/ACIntro';
import ACSolutions from './components/ACSolutions';
import SystemsWeService from './components/SystemsWeService';
import WhyChooseAC from './components/WhyChooseAC';
import ACBenefits from './components/ACBenefits';
import ACCTA from './components/ACCTA';

const ACMaintenanceServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>AC Maintenance Services | Reliable Climate Control | VASTECH</title>
        <meta
          name="description"
          content="Professional AC maintenance services by VASTECH. Reliable climate control for optimal building performance in residential, commercial, and industrial buildings."
        />
        <meta
          name="keywords"
          content="AC maintenance, HVAC services, climate control, preventive maintenance, UAE AC service, VASTECH HVAC"
        />
        <meta property="og:title" content="AC Maintenance Services | VASTECH" />
        <meta
          property="og:description"
          content="Expert AC maintenance focusing on preventative care, performance optimization, and system reliability."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://vastech.ae/ac-maintenance-services" />
      </Helmet>

      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-accent/30">
        <Header />

        <main className="relative">
          {/* Hero Section */}
          <ACHero />

          {/* Introduction */}
          <ACIntro />

          {/* Solutions Section */}
          <ACSolutions />

          {/* Types of Systems We Service */}
          <SystemsWeService />

          {/* Why Choose VASTECH */}
          <WhyChooseAC />

          {/* Benefits Section */}
          <ACBenefits />

          {/* Call to Action */}
          <ACCTA />
        </main>

        {/* Minimalistic Footer */}
        <Footer />
      </div>
    </>
  );
};

export default ACMaintenanceServices;